import React from "react";
import { useTranslation } from "react-i18next";
import { MODULES, ALL_MODULE_CODES } from "constant/modules";

// Scelta dei moduli acquistati dal cliente (almeno uno).
const ModulesPicker = ({ value = [], onChange, error }) => {
  const { t } = useTranslation("users");
  const toggle = (code) => {
    const next = value.includes(code)
      ? value.filter((c) => c !== code)
      : [...value, code];
    onChange(ALL_MODULE_CODES.filter((c) => next.includes(c)));
  };

  return (
    <div className="modules-picker">
      <label className="d-block w-100 text-left mb-1">{t("modules.title")}</label>
      <div className="modules-picker__grid">
        {MODULES.map((m) => (
          <label
            key={m.code}
            className={
              "modules-picker__item" +
              (value.includes(m.code) ? " is-on" : "")
            }
          >
            <input
              type="checkbox"
              checked={value.includes(m.code)}
              onChange={() => toggle(m.code)}
            />
            <span>
              <b>{m.label}</b>
              <small>{m.hint}</small>
            </span>
          </label>
        ))}
      </div>
      <div className="modules-picker__presets">
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => onChange(["wine"])}
        >
          {t("modules.wineOnly")}
        </button>
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => onChange(["food"])}
        >
          {t("modules.menuOnly")}
        </button>
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => onChange([...ALL_MODULE_CODES])}
        >
          {t("modules.all")}
        </button>
      </div>
      {error && <span className="error text-danger">{error}</span>}
    </div>
  );
};

export default ModulesPicker;
